import { lazy } from 'react';
import { PERMISSION_WATCH_V2 } from 'Constants';

export default {
  ui: 'hidden',
  auth: { role: PERMISSION_WATCH_V2 },
  // once legacy watch is fully replaced
  // - remove '-v2' in path and setView
  // - change ui to 'menuLeft'
  path: 'watch-v2',
  urlParams: '/:viewId?/:redirectId?',
  title: 'Watch',
  component: lazy(() => import('./index')),
};
